import { useApi } from '../composables'
import http from '../composables/src/useHttp'

export const getAllTicketCategories = () => {
  return useApi(http.get(`/settings/ticket-categories`))
}
export const deleteTicketCategory = (id: string) => {
  return useApi(http.delete(`/settings/ticket-categories/${id}`))
}
export const createTicketCategory = (data: any) => {
  return useApi(http.post(`/settings/ticket-categories`, data))
}
export const updateTicketCategory = (id: any, data: any) => {
  return useApi(http.patch(`/settings/ticket-categories/${id}`, data))
}
export const updateTicketCategoryPositions = (positions: { id: string; position: number }[]) => {
  return useApi(http.put(`/settings/ticket-categories/positions`, { positions }))
}
